import { ORDER_METHODS } from '../../../../services/exports/Constants';

export default {
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'commande à table',
    [ORDER_METHODS.PICKUP]: 'à emporter',
    [ORDER_METHODS.DELIVERY]: 'livraison',
  },
  errors: {
    draft_validation_failed: 'Veuillez compléter votre adresse de livraison avant de continuer.',
  },
};
